/**
 * This plugin fixes an issue where switching locales would not update the dayjs
 * instance.
 */
export default defineNuxtPlugin({
  name: 'dates',

  async setup(nuxtApp) {
    nuxtApp.hook('app:created', async () => {
      const locales = {
        en: () => import('dayjs/locale/en'),
        fr: () => import('dayjs/locale/fr'),
      } as const

      const { $i18n } = useNuxtApp()

      const localeKey = $i18n.locale.value === 'fr' ? 'fr' : 'en'
      const localeModule = await locales[localeKey]()

      datetime.locale(
        localeKey,
        localeModule.default,
      )
    })

    nuxtApp.hook('i18n:beforeLocaleSwitch', ({ newLocale }) => {
      datetime.locale(newLocale)
    })
  },
})
